document.addEventListener('DOMContentLoaded', function () {
  const mediaModals = document.querySelectorAll('.media-modal img');
  const modalU = document.querySelector('.media-modal');
  const sliderFor = document.querySelector('.slider-for');

  mediaModals.forEach((modal) => {
    modal.addEventListener('click', function () {
      modalU.classList.toggle('zoomed');
      const isZoomed = modalU.classList.contains('zoomed');

      if (sliderFor && typeof $ !== 'undefined') {
        $(sliderFor).slick('slickSetOption', 'swipe', !isZoomed, false);
        $(sliderFor).slick('slickSetOption', 'draggable', !isZoomed, false);
      }

      if (isZoomed) {
        const targetElement = document.querySelector(
          '.slick-product-modal.zoomed div.slick-current',
        );

        if (targetElement) {
          const scrollTarget = targetElement.scrollHeight * 0.15;

          targetElement.scrollTo({
            top: scrollTarget,
            behavior: 'smooth',
          });
        }
      }
    });
  });

  // Pinch-to-zoom on mobile
  if ('ontouchstart' in window) {
    const slides = document.querySelectorAll('.slider-for .slide');

    slides.forEach((slide) => {
      let scale = 1;
      let startDist = 0;
      let startScale = 1;
      let translateX = 0;
      let translateY = 0;
      let startX = 0;
      let startY = 0;
      let startTX = 0;
      let startTY = 0;
      let isPinching = false;

      const img = slide.querySelector('img');
      if (!img) return;

      img.style.transformOrigin = 'center center';
      img.style.willChange = 'transform';

      function getTouchDist(touches) {
        const dx = touches[0].clientX - touches[1].clientX;
        const dy = touches[0].clientY - touches[1].clientY;
        return Math.sqrt(dx * dx + dy * dy);
      }

      function applyTransform() {
        img.style.transform = `translate(${translateX}px, ${translateY}px) scale(${scale})`;
      }

      function setSlickSwipe(enabled) {
        if (sliderFor && typeof $ !== 'undefined') {
          $(sliderFor).slick('slickSetOption', 'swipe', enabled, false);
          $(sliderFor).slick('slickSetOption', 'draggable', enabled, false);
        }
      }

      slide.addEventListener(
        'touchstart',
        function (e) {
          if (e.touches.length === 2) {
            e.preventDefault();
            isPinching = true;
            startDist = getTouchDist(e.touches);
            startScale = scale;
            setSlickSwipe(false);
          } else if (e.touches.length === 1 && scale > 1) {
            e.preventDefault();
            startX = e.touches[0].clientX;
            startY = e.touches[0].clientY;
            startTX = translateX;
            startTY = translateY;
            setSlickSwipe(false);
          }
        },
        { passive: false },
      );

      slide.addEventListener(
        'touchmove',
        function (e) {
          if (e.touches.length === 2 && isPinching) {
            e.preventDefault();
            const dist = getTouchDist(e.touches);
            scale = Math.min(Math.max(startScale * (dist / startDist), 1), 4);
            if (scale === 1) {
              translateX = 0;
              translateY = 0;
            }
            applyTransform();
          } else if (e.touches.length === 1 && scale > 1) {
            e.preventDefault();
            translateX = startTX + (e.touches[0].clientX - startX);
            translateY = startTY + (e.touches[0].clientY - startY);
            applyTransform();
          }
        },
        { passive: false },
      );

      slide.addEventListener('touchend', function (e) {
        isPinching = false;
        if (scale <= 1) {
          scale = 1;
          translateX = 0;
          translateY = 0;
          applyTransform();
          setSlickSwipe(true);
          modalU.classList.remove('zoomed');
        }
      });
    });
  }
});
